import fetch from "auth/FetchInterceptor";

const QandAService = {};

QandAService.fetchQandAReport = function (payload) {
  return fetch({
    url:
      "/satisfaction-and-complaint?startDate=" +
      payload.startDate +
      "&endDate=" +
      payload.endDate,
    method: "get",
  });
};

QandAService.saveSatisfactionSurvery = function (payload) {
  return fetch({
    url: "/satisfaction-and-complaint",
    data: payload,
    method: "post",
  });
};

QandAService.saveComplainingSurvery = function (payload) {
  return fetch({
    url: "/satisfaction-and-complaint",
    data: payload,
    method: "post",
  });
};

QandAService.transferSatisfactionSurveryToWhomItMayConcern = function (
  payload
) {
  return fetch({
    url: "/transfer-satisfaction",
    data: payload,
    method: "post",
  });
};

QandAService.sendCustomerCommunicationWithComplainOfficer = function (payload) {
  return fetch({
    url: "/customer_communication_with_complain_officer",
    data: payload,
    method: "post",
  });
};

QandAService.confirmComplainOfficerMessage = function (payload) {
  return fetch({
    url: "/confirm_complain_officer_message",
    data: payload,
    method: "post",
  });
};

export default QandAService;
